<template>
<div class="chapter">
<div class="inner_page">
<p class="p5"><span class="sz"> </span></p>
<p class="p6"><span class="sz"><b>PART ONE</b></span></p>
<p class="p5"><span class="sz"> </span></p>
<p class="p6"><span class="sz"><b><i>'Neath His Bronzed Skin His Iron Muscles Played</i></b></span></p>
<p class="p2"><span class="sz"> </span></p>
<p class="p5"><span class="sz"><b></b> </span></p>
<p class="p5"><span class="sz"><b></b> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section4.vue?6d8a4884